import {sanitize} from 'isomorphic-dompurify';
import Mustache from 'mustache';

const allowedTags = ['h1', 'h2'];

const unescapedValue = Mustache.Writer.prototype.unescapedValue;

Mustache.Writer.prototype.unescapedValue = function (token, context) {
    const value = unescapedValue(token, context);
    return value ? sanitize(value, {ADD_TAGS: allowedTags}) : value;
};

export {Mustache as CustomMustache};
